<template>
  <basic-modal
    :is-showing="deleteMessage.show"
    title="Weet je zeker dat je dit wilt verwijderen?"
    :on-cancel="cancel"
    :on-submit="submit"
    submit-text="Verwijder"
    submit-icon="mdi-trash-can"
  >
    <v-checkbox
      v-model="forceDelete"
      label="Forceer verwijderen (Let op: alle informatie binnen deze entiteit gaat verloren)"
    />
  </basic-modal>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import BasicModal from '@bit/streamline.web.basic-modal'

export default {
  components: {
    BasicModal
  },
  data: () => {
    return {
      forceDelete: false
    }
  },
  computed: {
    ...mapState({
      deleteMessage: (state) => state.dialogs.deleteMessage
    })
  },
  methods: {
    ...mapActions(['rejectDelete', 'acceptDelete']),
    submit () {
      this.acceptDelete(this.forceDelete)
      this.forceDelete = false
    },
    cancel () {
      this.rejectDelete()
    }
  }
}
</script>
